export enum SysFlightCardComponentTypeEnum {
  AirframeLandings = 1,
  Engines = 2,
  APU = 3,
}
